// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc */
// Stories aren't SSR'd, so pointless to have them in a story.

import * as React from 'react';

type Props = {|
  /** If true, then server -> client rerendering is pushed to the end of the event queue */
  rerenderLast: boolean,
  children: (isClient: boolean) => React.Node,
|};
type State = {|
  isClient: boolean,
|};

/* istanbul ignore next */
// This has a test, but we disable code coverage since istanbul does a pretty terrible job counting branches here

class IsMountedClient extends React.Component<Props, State> {
  static defaultProps = {
    rerenderLast: false,
  };

  state = { isClient: false };

  componentDidMount() {
    if (this.props.rerenderLast) {
      setTimeout(this.setClient, 0);
    } else {
      this.setClient();
    }
  }

  setClient = () => {
    this.setState({ isClient: true });
  };

  render() {
    return this.props.children(this.state.isClient);
  }
}

/**
 * A render-prop component which allows you to render differently on the server vs the client
 * Be diligent about where this is used as this will cause a rerender on mount
 */
export default IsMountedClient;
